module.exports = __webpack_public_path__ + "static/media/flag-mi.6649eb00.webp";